var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3236 9.82308C17.902 9.93852 17.4582 10.0002 17 10.0002C14.2386 10.0002 12 7.76158 12 5.00016C12 4.65797 12.0344 4.32382 12.0999 4.00095C12.0666 4.00043 12.0333 4.00016 12 4.00016C8.77095 4.00016 6.05382 6.49102 5.67964 9.79419L5.33476 12.8387C5.24906 13.5952 4.94246 14.3071 4.45549 14.8802C3.42209 16.0966 4.26081 18.0002 5.83014 18.0002H18.1699C19.7392 18.0002 20.5779 16.0966 19.5445 14.8802C19.0575 14.3071 18.7509 13.5952 18.6652 12.8387L18.3236 9.82308ZM14.9721 20.0717C14.5147 21.1994 13.3565 22.0002 12 22.0002C10.6435 22.0002 9.48526 21.1994 9.02789 20.0717C9.00883 20.0247 9 19.9742 9 19.9235C9 19.6897 9.18951 19.5002 9.42329 19.5002H14.5767C14.8105 19.5002 15 19.6897 15 19.9235C15 19.9742 14.9912 20.0247 14.9721 20.0717Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5445 8.5C18.2014 8.5 19.5445 7.15685 19.5445 5.5C19.5445 3.84315 18.2014 2.5 16.5445 2.5C14.8876 2.5 13.5445 3.84315 13.5445 5.5C13.5445 7.15685 14.8876 8.5 16.5445 8.5Z",
    fill: "#FF5545"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationOn);
export default __webpack_public_path__ + "static/media/notification_on.09b5c6267cc49cfddc8443f33af6d3c6.svg";
export { ForwardRef as ReactComponent };